import { Avatar, CardContent, Grid, IconButton, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';
import { CallIcon, EmailIcon, WhatsAppIcon } from "../shared/icons";
import FacebookIcon from '@mui/icons-material/Facebook';

const RootGrid = styled(Grid)(({ theme }) => ({
    display: 'flex',
    padding: '1rem',
    textAlign: 'center',
    backgroundColor: `${theme.palette.secondary.light}`,
    color: 'black',
    [theme.breakpoints.down('sm')]: {
        textAlign: 'left'
    }
}));


function Footer() {

    return <RootGrid container direction="row" justifyContent="flex-start" alignItems="flex-start">
        <Grid container direction="row" justifyContent="flex-start">
            <Grid size={{xs: 12, md: 3}}>
                <Grid size={{xs: 12}} sx={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
                    <Avatar sx={{ width: "48", height: "48", marginRight: "12px" }} src="/favicon.ico"></Avatar>
                    <Typography><h2>Gyminify</h2></Typography>
                </Grid>
                <CardContent>
                    <Typography gutterBottom variant="body2" component="h2" color="inherit" align="justify">
                        Gyminify is an all-in-one solution for managing fitness centers. With detailed analytics, it's easy to improve member management, payment management, attendance tracking, staff management, and more. Gyminify provides accurate and timely information necessary to deliver tailored solutions to your business.
                    </Typography>
                </CardContent>
            </Grid>
            <Grid size={{xs:12, md: 2}} />
            <Grid size={{ lg: 2, md: 2, sm: 12, xs: 12 }}>
                <Typography gutterBottom variant="h6" component="h2" color="inherit" justifyContent="center" >Follow Us</Typography>
                <IconButton href="https://www.facebook.com/gyminifyapp" target="_blank" rel="noreferrer">
                    <FacebookIcon color="primary" fontSize="large"/>
                </IconButton>
                
            </Grid>
            <Grid size={{ lg: 2, md: 2, sm: 12, xs: 12 }} />
            <Grid size={{ lg: 3, md: 3, sm: 12, xs: 12 }}>
                <Typography gutterBottom variant="h6" component="h2" color="inherit" align="justify" sx={{pl: '16px'}}>Get in Touch</Typography>
                <List>
                    <ListItem>
                        <ListItemIcon><EmailIcon color="primary" /></ListItemIcon>
                        <ListItemText primary="gyminify@gmail.com" />
                    </ListItem>
                    <ListItem>
                       <ListItemIcon><CallIcon color="primary"/></ListItemIcon>
                       <ListItemText primary="+94 771 399 297" />
                    </ListItem>
                    <ListItem>
                       <ListItemIcon><WhatsAppIcon color="success"/></ListItemIcon>
                       <ListItemText primary="+94 771 399 297" />
                    </ListItem>
                </List>
            </Grid>
        </Grid>
        <Grid size={{xs: 12}}>
            Copyright ©{new Date().getFullYear()} <a
                href="https://www.gyminify.com" target="_blank" rel="noreferrer">Gyminify</a>. All rights reserved.
            {/*| <a href="https://gyminifyapp.net/terms-of-service">Terms</a> | <a href="https://gyminifyapp.net/privacy-policy">Privacy Policy</a>*/}
        </Grid>
    </RootGrid>
}

export default Footer